import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import { ShiftsPage } from './ShiftsPage';
import { ShiftSettingsPage } from './ShiftSettingsPage';
import type { BackofficeModule } from '../registry';

/** Baustein für „Mein Konto“: der eigene Schichtplan (KON-040) */
export { MyShifts } from './MyShifts';

/**
 * Einstiegspunkt des Moduls „Schichtplanung“ im Backoffice (KON-040). Alles dazu liegt in diesem Ordner. Das Backoffice kennt nur diese Datei (siehe registry.tsx).
 * Die Verträge zur API stehen in packages/shared/src/shifts. Die Vorgaben pflegt man in der Einrichtung. Der Bereich dort gehört zum Modul „setup“ (wie bei Produkten), sonst verschwände das Modul aus der Seitenleiste.
 */
export const shiftsModule: BackofficeModule = {
  key: 'shifts',
  path: '/schichtplanung',
  setupSections: [
    {
      path: 'schichtplanung',
      label: 'Schichtplanung',
      module: 'setup',
      permission: 'setup.read',
      requires: 'shifts',
      description: 'Arbeitstage, Beginn, Höchstarbeitszeit, Ruhezeit, Urlaubsgrenze je Monat und Sollstunden je Position.',
      built: true,
      group: 'team',
      keywords: ['Schicht', 'Arbeitszeit', 'Wochenstunden', 'Position', 'Urlaub', 'Ruhezeit', 'Dienstplan'],
    },
  ],
  setupRoutes: <Route path="schichtplanung" element={<ModuleGate module="setup" permission="setup.read"><ShiftSettingsPage /></ModuleGate>} />,
  routes: <Route path="schichtplanung" element={<ModuleGate module="shifts" permission="shifts.read"><ShiftsPage /></ModuleGate>} />,
};
